import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { AutoCompleteModule } from "@bfx/primeng/autocomplete";
import { ButtonModule } from "@bfx/primeng/button";
import { CheckboxModule } from "@bfx/primeng/checkbox";
import { DataTableModule } from "@bfx/primeng/datatable";
import { DropdownModule } from "@bfx/primeng/dropdown";
import { InputMaskModule } from "@bfx/primeng/inputmask";
import { InputTextModule } from "@bfx/primeng/inputtext";
import { SpinnerModule } from "@bfx/primeng/spinner";
import { ToggleButtonModule } from "@bfx/primeng/togglebutton";
import { TranslateModule } from "@ngx-translate/core";
import { FlexLayoutModule } from "@angular/flex-layout";

import { BfxSharedModule } from "../bfx-shared/bfx-shared.module";
import { BfxElementsLibraryModule } from "..//bfx-element-library/bfx-elements-library.module";
import { NativeDesktopModule } from "../bfx-native-desktop/native-desktop-support.module";
import { ICFixedCcyComponent } from "./ic-fixed-ccy.component";
import { BaseComponentsModule } from "shared/base-components/base-components.module";

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    FlexLayoutModule,
    FormsModule,
    DataTableModule,
    InputTextModule,
    CheckboxModule,
    AutoCompleteModule,
    ButtonModule,
    ToggleButtonModule,
    SpinnerModule,
    DropdownModule,
    InputMaskModule,
    BfxElementsLibraryModule,
    BfxSharedModule,
    NativeDesktopModule,
    BaseComponentsModule,
  ],
  declarations: [ICFixedCcyComponent],
  providers: [],
  exports: [ICFixedCcyComponent],
})
export class ICControlsModule {}
